import React, { useEffect, useState } from 'react'
import ClientLayout from '../layout/ClientLayout'
import ClientSearchComponent from '../components/ClientSearchComponent'

import ClientAppointmentBooking from '../../appointments/components/ClientAppointmentBooking';
import ClientDetailsComponent from '../components/ClientDetailsComponent';
import useClientDetails from '../../../hooks/useClientDetails';
import { LinearProgress } from '@mui/material';

function ClientSearchPage() {
  
  const [clientId,setClientId] = useState("");
  const [clientDetails,getClientDetails,loading] = useClientDetails();
  useEffect(()=>{
    getClientDetails(clientId);
  },[clientId])


  return (
    <ClientLayout>
      <ClientSearchComponent setClientId={setClientId} />
      {loading && 
        <div className='row mt-2'>
          <div className='col-md-12 text-center'>
            <LinearProgress />
          </div>
        </div>
      }
      {clientDetails &&
        <div className='row mt-2'>
          <div className='col-md-8'>
            <ClientDetailsComponent clientDetails={clientDetails}/>
          </div>
          <div className='col-md-4'>
            <ClientAppointmentBooking clientId={clientId}/>
          </div>
        </div>
      }
    </ClientLayout>
  )
}

export default ClientSearchPage